import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SedsRadioButtonComponent } from './seds-radio-button.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SedsRadioButtonComponent],
  imports: [CommonModule, MatRadioModule, FormsModule, ReactiveFormsModule],
  exports: [SedsRadioButtonComponent, MatRadioModule],
})
export class SedsRadioButtonModule {}
